import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import translate from "i18n/translate";
import basicAuthRequest from "axios/basicAuthRequest";
import { ACCOUNT_RESET_PASSWORD_TOKEN } from "../../../../constants/api";
import { RECOVER_PASS_TOKEN_EXPIRATION_TIME } from "../../../../constants";
import { AUTH_ROOT_ROUTE, LOGIN_ROUTE } from "routes/auth/authPaths";

const useRecoverPassword = () => {
  const [error, setError] = useState("");
  const { token, ssoId, confirmationCode, confirmationToken, epoch } =
    useParams();
  const history = useHistory();

  const handleSubmit = async ({ password, confirmPassword }) => {
    setError("");

    try {
      await basicAuthRequest.put(
        ACCOUNT_RESET_PASSWORD_TOKEN.replace("{ssoId}", ssoId || token),
        {
          confirmation_code: confirmationCode,
          confirmation_token: confirmationToken,
          password,
          confirm_password: confirmPassword,
        }
      );

      toast.success(translate("auth.recoverPasswordSuccess"));
      history.push(`${AUTH_ROOT_ROUTE}${LOGIN_ROUTE}`);
    } catch (err) {
      setError(
        err.response?.data?.error?.message || translate("errors.somethingWrong")
      );
    }
  };

  useEffect(() => {
    const checkTokenValidity = () => {
      const isValidEpoch =
        epoch && Date.now() - epoch * 1000 < RECOVER_PASS_TOKEN_EXPIRATION_TIME;

      if (!isValidEpoch) {
        toast.error(translate("auth.recoveryTokenExpired"));
        history.push(`${AUTH_ROOT_ROUTE}${LOGIN_ROUTE}`);
      }
    };

    if (epoch) checkTokenValidity();
  }, [history, epoch, error]);

  return {
    error,
    handleSubmit,
  };
};

export default useRecoverPassword;
